module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.totalResults && _vm.activePage) ? _c('small', [_c('b', [_vm._v(_vm._s(_vm.pageStart))]), _vm._v(" - "), _c('b', [_vm._v(_vm._s(_vm.pageEnd))]), _vm._v(" of "), _c('b', [_vm._v(_vm._s(_vm.totalResults))]), _vm._v(" results")]) : _vm._e(), _vm._v(" "), _c('b', {
    staticClass: "margin-left-5 margin-right-5"
  }, [_vm._v("|")]), _vm._v(" "), _c('small', [_vm._v("Show")]), _vm._v(" "), _c('el-dropdown', {
    attrs: {
      "trigger": "click",
      "size": "mini",
      "show-timeout": 50,
      "hide-timeout": 50
    },
    on: {
      "command": _vm.updateResultsPerPage
    }
  }, [_c('el-button', {
    attrs: {
      "size": "mini"
    }
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.resultsPerPage) + "\n\t\t\t"), _c('i', {
    staticClass: "el-icon-arrow-down el-icon--right"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    attrs: {
      "command": 25
    }
  }, [_vm._v("25")]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "command": 50
    }
  }, [_vm._v("50")]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "command": 100
    }
  }, [_vm._v("100")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4ae75106"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/PageResults.vue
// module id = 711
// module chunks = 0